import { ENV } from 'config/ENV.config'

/**
 * Set the browser tab title from an explicit title, else from the URL path.
 *
 * This — not the `<title>` in public/index.html — is what the user actually sees: it runs on
 * every render from App.tsx, so it overwrites the interpolated markup as soon as React mounts.
 * The brand suffix therefore has to be applied here, or a rebranded build still reads "ErpBoi"
 * everywhere except the first paint.
 */
export const setWindowTitle = (title: string = null) => {
  const t = title || window.location.pathname?.split('/')?.slice(1)?.join(' - ')
  const page = t ? t.charAt(0).toUpperCase() + t.slice(1) : ''
  document.title = page ? `${page} | ${ENV.brandName}` : ENV.brandName
}

/**
 * Split the brand name for the two-tone wordmark on the auth page, where the second half is
 * rendered in the accent colour (`.auth-wordmark span`).
 *
 * Splits at the last lowercase->uppercase boundary, which is what the name is actually built
 * from: "ErpBoi" -> Erp|Boi, "PhoenixERP" -> Phoenix|ERP. Falls back to halfway for an
 * all-one-case name, and to no accent for a single character.
 */
export const splitWordmark = (name: string): [string, string] => {
  const n = name || ''
  if (n.length < 2) return [n, '']
  const m = n.match(/^(.*[a-z])([A-Z].*)$/)
  if (m) return [m[1], m[2]]
  const half = Math.ceil(n.length / 2)
  return [n.slice(0, half), n.slice(half)]
}

export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export const getUrlFromJson = (jsonStr) => {
  if (jsonStr) {
    return ENV.apiEndpoint + '/' + JSON.parse(jsonStr).url
  }
  return ''
}

export const monthOptions = [
  { name: 'January', value: '01' },
  { name: 'February', value: '02' },
  { name: 'March', value: '03' },
  { name: 'April', value: '04' },
  { name: 'May', value: '05' },
  { name: 'June', value: '06' },
  { name: 'July', value: '07' },
  { name: 'August', value: '08' },
  { name: 'September', value: '09' },
  { name: 'October', value: '10' },
  { name: 'November', value: '11' },
  { name: 'December', value: '12' },
]

export const monthShortOptions = [
  { name: 'Jan', value: '01' },
  { name: 'Feb', value: '02' },
  { name: 'Mar', value: '03' },
  { name: 'Apr', value: '04' },
  { name: 'May', value: '05' },
  { name: 'Jun', value: '06' },
  { name: 'Jul', value: '07' },
  { name: 'Aug', value: '08' },
  { name: 'Sep', value: '09' },
  { name: 'Oct', value: '10' },
  { name: 'Nov', value: '11' },
  { name: 'Dec', value: '12' },
]

export const getUrlFromJsonArray = (jsonArrStr) => {
  if (jsonArrStr) {
    return ENV.apiEndpoint + '/' + JSON.parse(jsonArrStr)[0].url
  }
  return ''
}
